// extracted by mini-css-extract-plugin
export default {"loading":"calendar_loading__rsyTa","calendar":"calendar_calendar__-MLHC"};